exports = module.exports = require("../../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "\n.comment-template-dropdown .gl-new-dropdown-panel {\n  width: 350px !important;\n}\n.comment-template-dropdown .gl-new-dropdown-item-check-icon {\n  display: none;\n}\n.comment-template-dropdown input {\n  border-radius: 0;\n}\n", ""]);

